<template>
    <a-drawer :title="$t('program.upload_video_management' /* 视频上传管理 */)" width="85%" placement="right" :closable="true" :visible="visible" @close="handleDrawerClose">
        <iframe :src="url" scrolling="no" id="receiver" width="100%" height="100%" style="border: 0"></iframe>
    </a-drawer>
</template>

<script>
export default {
    name: 'uploadVideoDrawer',
    props: {},
    components: {},
    data() {
        return {
            visible: false,
            url: ''
        };
    },
    computed: {},
    methods: {
        show() {
            this.visible = true;
        },
        //关闭抽屉
        handleDrawerClose() {
            this.visible = false;
        }
    },
    created() {},
    mounted() {
        this.url = `${this.$store.state.meetingInfo.domain}/program/session/program-view/${this.$route.params.meeting_id}`;
    }
};
</script>
<style lang='less' scoped>
::v-deep .ant-drawer-body {
    max-height: 72vh;
    overflow-y: auto;
}
</style>